import { render, staticRenderFns } from "./JTime.vue?vue&type=template&id=16a94bf2&scoped=true&"
import script from "./JTime.vue?vue&type=script&lang=js&"
export * from "./JTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a94bf2",
  null
  
)

export default component.exports